/**
 * Query Key factory for all staff earnings queries.
 *
 * @module Earnings
 */

export const earningsQKeys = {
  all: () => ["earnings"] as const,

  summary: () => [...earningsQKeys.all(), "summary"] as const,
  
  summaryWithFilters: (filters: { startDate?: string; endDate?: string }) => 
    [...earningsQKeys.summary(), { ...filters }] as const,

  breakdown: () => [...earningsQKeys.all(), "breakdown"] as const,

  breakdownWithFilters: (filters: { startDate?: string; endDate?: string; page?: number; pageSize?: number }) => 
    [...earningsQKeys.breakdown(), { ...filters }] as const,

  tier: () => [...earningsQKeys.all(), "tier"] as const,
};
